export default __webpack_public_path__ + "static/media/Linkedin Learning Java.b81b670d.webp";